import Facebook from 'components/Svg/Facebook';
import Twitter from 'components/Svg/Twitter';
import Instagram from 'components/Svg/Instagram';
import LinkedIn from 'components/Svg/LinkedIn';
import Youtube from 'components/Svg/Youtube';
import Tiktok from 'components/Svg/Tiktok';
import Mastodon from 'components/Svg/Mastodon';
import Threads from 'components/Svg/Threads';

const isUrl = (val) => {
    const urlPattern =
        /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
    return urlPattern.test(val);
};

const isSocial = (val, socialTypes) => {
    for (const item of socialTypes) {
        if (
            val.includes(`${item}.com`) ||
            val.includes(`${item}.social`) ||
            val.includes(`${item}.net`)
        ) {
            if (item === 'x') {
                return 'twitter';
            }
            return item;
        }
    }
};

const formatUrl = (val) => {
    val = val.trim();

    // if url begins with "//"
    if (val.substring(0, 2) === '//') {
        val = val.split('//').join('');
    }

    // if url contains "http://"
    if (val.includes('http://')) {
        val = val.split('http://').join('');
    }

    // if url contains "https://"
    if (val.includes('https://')) {
        val = val.split('https://').join('');
    }

    // if url contains "www."
    if (val.includes('www.')) {
        val = val.split('www.').join('');
    }

    // if url has attributes
    // if (val.includes('?')) {
    //     val = val.split('?')[0];
    // }

    // if url has a trailing slash
    if (val.substring(val.length - 1, val.length) === '/') {
        val = val.slice(0, -1);
    }

    return `https://${val}`;
};

const getSocialIcon = (name) => {
    let icon;

    switch (name) {
        case 'facebook':
            icon = <Facebook fill="#212121" />;
            break;
        case 'twitter':
            icon = <Twitter fill="#212121" />;
            break;
        case 'instagram':
            icon = <Instagram fill="#212121" />;
            break;
        case 'linkedin':
            icon = <LinkedIn fill="#212121" />;
            break;
        case 'youtube':
            icon = <Youtube fill="#212121" />;
            break;
        case 'tiktok':
            icon = <Tiktok fill="#212121" />;
            break;
        case 'mastodon':
            icon = <Mastodon fill="#212121" />;
            break;
        case 'threads':
            icon = <Threads fill="#212121" />;
            break;
        default:
            icon = null;
            break;
    }

    return icon;
};

export { isUrl, isSocial, formatUrl, getSocialIcon };
